export default __webpack_public_path__ + "static/media/vvisualized.699d4451.png";